import {selectDoc, styles, event} from "../utils/utils";

import doCookies from '../lib/docookies.min.js'

const props = {
    body: selectDoc("body"),
    container: selectDoc("#cookies-container"),
    close: selectDoc("#cookies-container .btn--close"),
}

const displayBanner = async () => {
    let cookieVal = doCookies.getItem('wscookie');
    if (cookieVal == 'false' || cookieVal == null) {
        doCookies.setItem('wscookie', 'false');
        props.container.classList.remove('hide');
        props.body.classList.add('cookies');
    } else {
        props.container.classList.add('hide');
        props.body.classList.remove('cookies');
    }

    event(props.close, 'click', function () {
        props.container.classList.add('hide');
        props.body.classList.remove('cookies');
        doCookies.setItem('wscookie', 'true');
    })
}

const initializer = () => {
    displayBanner();
}

export const Cookies = {
    init: () => initializer()
}
